
import StreetViewPanorama from '~/components/map/components/StreetViewPanorama.vue'
import param from '~/utils/url/param'
import isEmail from '~/utils/validations/email'
export default {
  components: { StreetViewPanorama },
  props: ['image'],
  data() {
    return {
      valid: !0,
      form: {
        name: '',
        email: '',
        message: ''
      },
      rules: {
        name: [(v) => !!v || 'Nome é obrigatório'],
        email: [
          (v) => !!v || 'E-mail é obrigatório',
          (v) => isEmail(v) || 'E-mail deve ser válido'
        ],
        message: [(v) => !!v || 'Mensagem é obrigatória']
      },
      lazy: !1,
      days: [
        { day: 1, name: 'segunda-feira', status: !1, times: [] },
        { day: 2, name: 'terça-feira', status: !1, times: [] },
        { day: 3, name: 'quarta-feira', status: !1, times: [] },
        { day: 4, name: 'quinta-feira', status: !1, times: [] },
        { day: 5, name: 'sexta-feira', status: !1, times: [] },
        { day: 6, name: 'sábado', status: !1, times: [] },
        { day: 0, name: 'domingo', status: !1, times: [] }
      ],
      list: []
    }
  },
  async created() {
    const vm = this,
      days = vm.days,
      r = await axios.get('site/horarios')
    days.filter((item) => {
      let { day, name, status } = item,
        add = !1
      const _times = []
      r.filter((t) => {
        if (day.toString() === t.day.toString()) {
          _times.push({
            start: t.start,
            end: t.end,
            error: '',
            remove: !0
          })
        }
      })
      status = _times.length > 0
      if (_times.length > 0) {
        if (_times.length === 1) {
          _times[0].remove = !1
        }
        add = !0
      }
      vm.list.push({ day, name, times: _times, add, status })
    })
  },
  computed: {
    site() {
      return site
    },
    color() {
      const { themes } = this.site
      return this.$vuetify.theme.isDark ? themes.dark : themes.light
    },
    height() {
      let size = 180,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 180
      else if (sm) size = 200
      else if (mdAndUp) size = 280
      return size
    }
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        const r = await this.$store.dispatch('app/sendEmail', this.form)
        if (r.msg) {
          this.$alert.success('Email enviado com sucesso.')
          this.form = {
            name: '',
            email: '',
            message: ''
          }
        } else {
          this.$alert.error('Email não enviado')
        }
      }
    },
    openWhats() {
      return `https://api.whatsapp.com/send${param({
        phone: '55' + site.whatsapp.replace(/[^0-9]+/g, ''),
        text: 'Quero marcar uma consulta pelo whatsapp'
      })}`
    },
    repeat(string, n) {
      let result = ''
      if (!string || n < 1 || n > Number.MAX_SAFE_INTEGER) {
        return result
      }
      do {
        if (n % 2) {
          result += string
        }
        n = Math.floor(n / 2)
        if (n) {
          string += string
        }
      } while (n)

      return result
    }
  }
}
